import { useContext } from "react";
import { DurationDistance } from "~/generated/graphql.types";
import { EditModeContext } from "../../../..";
import { SpotStatEntity } from "./SpotStatEntity";
import { SpotStatDummy } from "./SpotStatDummy";
import { AddMarginLeft } from "../../ComponentLayouter/AddMarginLeft";
import { WriteLeftDotLine } from "../../ComponentLayouter/WriteLeftDotLine";
import { Flex } from "@chakra-ui/react";

export const SpotStatInterface = ({
  stat,
  hasLeftMargin,
}: {
  stat: DurationDistance | undefined | null;
  hasLeftMargin: boolean;
}) => {
  const { editMode } = useContext(EditModeContext);

  const Wrapper = hasLeftMargin ? AddMarginLeft : Flex;
  if (stat === undefined || stat === null || editMode === "contents") {
    return (
      <Wrapper>
        <WriteLeftDotLine>
          <SpotStatDummy />
        </WriteLeftDotLine>
      </Wrapper>
    );
  } else {
    return (
      <Wrapper>
        <WriteLeftDotLine>
          <SpotStatEntity stat={stat} />
        </WriteLeftDotLine>
      </Wrapper>
    );
  }
};
